module.exports = __webpack_public_path__ + "static/media/eplore card.f9a1d7e3.jpg";